import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import './PublicPage.css';

export default function PublicPage() {
  const { tenantSlug } = useParams();
  const [tables, setTables] = useState(null);
  const [names, setNames] = useState({});

  useEffect(() => {
    axios
      .get(`/${tenantSlug}/api/tables`)
      .then(res => setTables(res.data))
      .catch(console.error);
  }, [tenantSlug]);



  const handleJoin = async (e, tableId) => {
    e.preventDefault();
    const name = names[tableId];
    if (!name) return;

    try {
      await axios.post(`/${tenantSlug}/api/tele`, { name, tableId });
      alert('Request sent!');
      setNames(n => ({ ...n, [tableId]: '' }));
    } catch (err) {
      console.error(err);
      alert('Oops, something went wrong.');
    }
  };

  //LEAVE THIS LINE
  if (!tables) return <p>Loading…</p>;

  return (
    <div className="public-page">
      <h2 className="public-page__title">Public View: {tenantSlug}</h2>
      <ul className="public-page__list">
        {tables.map(t => (
          <li key={t.id} className="public-page__item">
            <div className="public-page__info">
              <strong>{t.stakes} {t.gameType}</strong> – {t.num_players} playing, {t.waitlist} waiting {t.bombs ? '💣' : ''}
            </div>
            <form
              className="public-page__form"
              onSubmit={e => handleJoin(e, t.id)}
            >
              <input
                className="public-page__input"
                type="text"
                placeholder="Your Name"
                value={names[t.id] || ''}
                onChange={e => setNames(n => ({ ...n, [t.id]: e.target.value }))}
                required
              />
              <button
                type="submit"
                className="public-page__button"
              >
                Join Waitlist
              </button>
            </form>
          </li>
        ))}
      </ul>
    </div>
  );

}